export type OverscrollProps = {
  element: HTMLDivElement;
  currentChild: number;
  setCurrentChild: (newChild: number) => void;
  gap: number;
  onChange: ((scroll: number) => void) | undefined;
  setInScrollNow: (isScroll: boolean) => void;
  direction: 'left' | 'right' | undefined;
  fullScroll: boolean | undefined;
};

/**
 * Calculates offset in px to scroll carousel block
 * */

export const overscroll = ({
  element,
  currentChild,
  gap,
  setInScrollNow,
  direction,
  fullScroll,
}: OverscrollProps) => {
  const { scrollLeft } = element;
  let calcChild = element.children[currentChild];
  if (fullScroll) {
    calcChild = element.children[element.children.length - 1];
  }
  if (direction === 'left') {
    calcChild = element.children[currentChild - 1];
    if (fullScroll) {
      calcChild = element.children[0];
    }
  }
  const scrolledElem = calcChild && calcChild.clientWidth;
  const step = scrolledElem + gap;
  setInScrollNow(true);
  let offset = step * currentChild;
  if (direction === 'left') {
    offset = scrollLeft - step;
    if (fullScroll) {
      offset = 0;
    }
  }
  if (direction === 'right') {
    offset = scrollLeft + step;
    if (fullScroll) {
      offset = step * (element.children.length - 1);
    }
  }
  return { offset };
};
